import "./RelatedTickets.css";
import { FiX } from "react-icons/fi";

function ticketTitle(value, fallback) {
	const nextValue = String(value || "").trim();
	if (!nextValue) {
		return fallback;
	}
	return nextValue;
}

function TicketGroup({ title, tickets = [], typeLabel, relationIds = {}, onOpenTicket, onUnlink, unlinkingRelationId }) {
	return (
		<section className="it-incident-related-group">
			<div className="it-incident-related-group-header">
				<h4>{title}</h4>
				<span>{tickets.length}</span>
			</div>
			{tickets.length === 0 ? (
				<p className="it-incident-related-empty">No {typeLabel}s found.</p>
			) : (
				<ul className="it-incident-related-list">
					{tickets.map((ticket) => {
						const relationId = relationIds?.[String(ticket?.id)];
						const isUnlinking = String(unlinkingRelationId || "") === String(relationId || "");

						return (
							<li key={ticket?.id} className="it-incident-related-item">
								<button type="button" className="it-incident-related-open" onClick={() => onOpenTicket?.(typeLabel, ticket)} disabled={!onOpenTicket}>
								<div className="it-incident-related-item-content">
									<div className="it-incident-related-primary-row">
										<strong>{ticket?.number || `${typeLabel.toUpperCase()}-${ticket?.id || "?"}`}</strong>
										<span>{ticket?.status || "-"}</span>
									</div>
									<div className="it-incident-related-secondary-row">
										<span>{ticketTitle(ticket?.title, "Untitled")}</span>
										<span>{ticket?.priority || "-"}</span>
									</div>
								</div>
								</button>
								{relationId && onUnlink ? (
									<button
										type="button"
										className="it-incident-related-unlink"
										onClick={() => onUnlink({ relationId, ticket, ticketType: typeLabel })}
										disabled={isUnlinking}
										title={`Unlink ${typeLabel}`}
									>
										<FiX aria-hidden="true" />
										<span>{isUnlinking ? "Unlinking..." : "Unlink"}</span>
									</button>
								) : null}
							</li>
						);
					})}
				</ul>
			)}
		</section>
	);
}

export default function RelatedTickets({
	data,
	loading,
	error,
	showProblems = true,
	showChanges = true,
	onOpenTicket,
	onUnlink,
	unlinkingRelationId,
}) {
	const relatedGraph = data || {
		problems: [],
		related_incidents: [],
		related_changes: [],
		direct_relation_ids: {},
	};
	const directRelationIds = relatedGraph.direct_relation_ids || {};

	return (
		<div className="it-incident-related-wrapper">
			{loading ? <p className="it-incident-related-loading">Loading related tickets...</p> : null}
			{error ? <p className="it-incident-related-error">{error}</p> : null}
			{!loading && !error ? (
				<>
					{showProblems ? (
						<TicketGroup title="Related Problems" tickets={relatedGraph.problems} typeLabel="problem" relationIds={directRelationIds.problems} onOpenTicket={onOpenTicket} onUnlink={onUnlink} unlinkingRelationId={unlinkingRelationId} />
					) : null}
					<TicketGroup title="Related Incidents" tickets={relatedGraph.related_incidents} typeLabel="incident" relationIds={directRelationIds.related_incidents} onOpenTicket={onOpenTicket} onUnlink={onUnlink} unlinkingRelationId={unlinkingRelationId} />
					{showChanges ? (
						<TicketGroup title="Related Changes" tickets={relatedGraph.related_changes} typeLabel="change" relationIds={directRelationIds.related_changes} onOpenTicket={onOpenTicket} onUnlink={onUnlink} unlinkingRelationId={unlinkingRelationId} />
					) : null}
				</>
			) : null}
		</div>
	);
}
